import React, { useState, useRef, useEffect } from "react";
import "./ChiefDashbord.css";
import ChiefDashbord_sidebar from "../sidebar/ChiefDashbord_sidebar";
import { BiLogOut, BiTrash } from "react-icons/bi";
import { RiSearch2Line } from "react-icons/ri";
import { BsPlusSquare } from "react-icons/bs";
import ChiefDashbord_filters from "./ChiefDashbord_filters/ChiefDashbord_filters";
import DropDown2 from "../../../Components/DropDown2/DropDown2";
import CheckBox from "../../../Components/CheckBox/CheckBox";
import ProfileImage from "../../../user.png";
import ChiefDashbord_Chart from "./ChiefDashbord_Chart";
import ChiefDashbord_Text from "./ChiefDashbord_Text";
import BuildingBox from "../../../Components/BuildingBox/BuildingBox";
import { HiMenu } from "react-icons/hi";
import PersonBox from "../../../Components/PersonBox/PersonBox";
import Drawer from "@mui/material/Drawer";
import useDocumentTitle from "../../../Components/TitleSetter/useDocumentTitle";
import ChiefDashbord_sidebar_res from "../sidebar/ChiefDashbord_sidebar_res";

function ChiefDashbord() {
    useDocumentTitle("باهم | داشبورد مدیریتی | پیشخوان");
    const [DP_DrawerB, setDP_DrawerB] = useState(false);

    let persons = [
        {
            rowNumber: 1,
            userName: "Ali_mohammadi ",
            name: "علی محمدی",
            email: "Ali_mohammadi@gmail.com",
            status: "کارشناس بازدید",
        },
    ];
    let buildings = [
        {
            rowNumber: 1,
            buildingCode: 431268,
            owner: "علی محمدی",
            expertName: "حسین احسانی",
            from: "باهم",
            state: "جدید",
            paid: "نقدی",
        },
        {
            rowNumber: 1,
            buildingCode: 431268,
            owner: "علی محمدی",
            expertName: "حسین احسانی",
            from: "باهم",
            state: "در حال ارزیابی",
            paid: "نقدی",
        },
        {
            rowNumber: 1,
            buildingCode: 431268,
            owner: "علی محمدی",
            expertName: "حسین احسانی",
            from: "باهم",
            state: "ارجاع شده",
            paid: "نقدی",
        },
        {
            rowNumber: 1,
            buildingCode: 431268,
            owner: "علی محمدی",
            expertName: "حسین احسانی",
            from: "باهم",
            state: "تکمیل شده",
            paid: "نقدی",
        },
    ];

    const [postFilter, setPostFilter] = useState(1);

    const optionsList1 = [
        { label: "املاک", value: "املاک" },
        { label: "بازاریاب", value: "بازاریاب" },
        { label: "باهم", value: "باهم" },
        { label: "مستقیم", value: "مستقیم" },
    ];
    const header = useRef(null);
    useEffect(() => {
        header.current.scrollIntoView({ behavior: "smooth" });
    }, []);
    return (
        <div className="ChiefDashbord" ref={header}>
            <div className="ChiefDashbord_SidebarContainer">
                <ChiefDashbord_sidebar ChiefName="کاربر مدیر ارشد" path="" userProfile={ProfileImage} sidebar={1} />
            </div>

            <div className="ChiefDashbord_Feed">
                <div className="ChiefDashbord_FeedHeader">
                    <div className="ChiefDashbord_FeedHeaderTitleContainer">
                        <div className="ChiefDashbord_sideBarOpenIconContainer" onClick={() => setDP_DrawerB(true)}>
                            <HiMenu className="ChiefDashbord_sideBarOpenIcon" />
                        </div>
                        <div className="ChiefDashbord_FeedHeaderTitleBor"></div>
                        <span className="ChiefDashbord_FeedHeaderTitle">داشبورد مدیر ارشد</span>
                    </div>

                    <div className="ChiefDashbord_FeedHeaderLogin">
                        <span className="ChiefDashbord_FeedHeaderLoginTitle1">وارد شده به عنوان</span>
                        <span className="ChiefDashbord_FeedHeaderLoginTitle2">مدیر ارشد</span>
                        <div className="ChiefDashbord_FeedHeaderLogout">
                            <span className="ChiefDashbord_FeedHeaderLogoutTitle">خروج</span>
                            <div className="ChiefDashbord_FeedHeaderLogoutIcon">
                                <BiLogOut />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ChiefDashbord_FeedContent" style={{ textAlign: "right", position: "relative", height: "100vh" }}>
                    <img style={{ display: "inline-block", position: "absolute", top: "24px", right: "42px" }} src="./images/cube.png" />
                    <p style={{ width: "60%", display: "inline-block", fontSize: "1.5rem", color: "#636e72", padding: "28px 90px" }}>
                        به پنل کاربری <span style={{ color: "black" }}> مدیر ارشد </span> خوش آمدید !
                    </p>
                    <img style={{ display: "inline-block", position: "absolute", bottom: "0", left: "42px" }} src="./images/dashboard-logo.png" />
                </div>
            </div>
            <Drawer className="Links_DrawerChiefBoard" anchor={"right"} open={DP_DrawerB} onClose={() => setDP_DrawerB(false)}>
                <div className="Links_DrawerChiefBoardContainer">
                    <ChiefDashbord_sidebar_res setDP_DrawerB={setDP_DrawerB} ChiefName="متین نوروزپور" path="" marginTop="0px" userProfile={ProfileImage} sidebar={1} />
                </div>
            </Drawer>
        </div>
    );
}

export default ChiefDashbord;
